export default function Hero() {
  return <div className="hero-shell">
    <div className="wrap">
      <section className="hero" id="hero">
        <div>
          <p className="eyebrow">Independent software engineer · Seattle</p>
          <h1>From first idea{' '}<br />to <span>shipped{' '}<br />software.</span>
          </h1>
          <p className="hero-copy">I help startups, businesses, and agencies build web apps, mobile apps, and the systems behind them. Work directly with the engineer building your product.</p>
          <div className="actions">
            <a className="btn primary" href="mailto:benrstewart.12@gmail.com">Tell me about your project <span aria-hidden="true">↗</span>
            </a>
            <a className="btn secondary" href="https://www.benstewart.dev/" target="_blank" rel="noopener noreferrer">View my work <span aria-hidden="true">↗</span>
            </a>
          </div>
          <p className="small-note">Freelance projects · Contract engineering · Technical consulting</p>
        </div>
        <aside className="path">
          <p className="path-label">HOW WE CAN WORK TOGETHER</p>
          <h2>A clear path to{' '}<br />your next release.</h2>
          <div className="step">
            <span className="step-number">01</span>
            <div>
              <h3>Define the right scope</h3>
              <p>Turn your idea or backlog into a focused plan.</p>
            </div>
          </div>
          <div className="step">
            <span className="step-number">02</span>
            <div>
              <h3>Build what matters</h3>
              <p>Connect the interface, APIs, and infrastructure.</p>
            </div>
          </div>
          <div className="step">
            <span className="step-number">03</span>
            <div>
              <h3>Get it ready to ship</h3>
              <p>Test, deploy, and plan the next iteration.</p>
            </div>
          </div>
        </aside>
      </section>
      <div className="audiences">
        <span className="label">WHERE I CAN HELP</span>
        <span>
          <strong>Startups</strong> / Build your first product</span>
        <span>
          <strong>Businesses</strong> / Improve your systems</span>
        <span>
          <strong>Agencies</strong> / Extend your team</span>
      </div>
    </div>
  </div>;
}
